import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

const ResetPasswordForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  
  const { resetPassword, isLoading, error } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      await resetPassword(email);
      setIsSubmitted(true);
    } catch (error) {
      // Error is handled by the store
    }
  };

  if (isSubmitted) {
    return (
      <div className="reset-password-form">
        <div className="logo-container">
          <div className="logo-badge">
            <span className="logo-icon"></span>
            <span className="logo-text">FinRacer</span>
          </div>
        </div>

        <div className="success-message">
          <div className="success-icon"></div>
          <h2>Recovery Email Sent</h2>
          <p>
            If an account exists for <strong>{email}</strong>, you will receive an email with instructions
            to reset your password. Please check your inbox and spam folder.
          </p>
          <button 
            className="button primary-button" 
            onClick={() => navigate('/login')}
          >
            Return to Sign In
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="reset-password-form">
      <div className="logo-container">
        <div className="logo-badge">
          <span className="logo-icon"></span>
          <span className="logo-text">FinRacer</span>
        </div>
        <p className="logo-tagline">Accelerating Financial Validation</p>
      </div>
      
      <h2>Reset Your Password</h2>
      <p className="form-description">
        Enter your email address below and we'll send you instructions to reset your password.
      </p>
      
      <form onSubmit={handleSubmit}>
        {error && <div className="error-message">{error}</div>}
        
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            required
          />
        </div>
        
        <div className="form-actions">
          <button type="submit" disabled={isLoading}>
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>
          
          <div className="form-links">
            <button 
              type="button" 
              className="link-button"
              onClick={() => navigate('/login')}
            >
              Back to Sign In
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ResetPasswordForm; 